import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { showToastNotification } from "../../App/state/actions";
import { trackGenericAction } from "../../shared/analytics/dataLayer";
import { ANALYTICS_EVENT_TYPES, NOTIFICATION_TYPES } from "../../shared/constants/analytics";
import constants from "../../shared/constants";
import { useReducers } from "../../shared/hooks/useReducer";
import { ToastContainer } from "./ToastNotification.styles";

const { REDUCER_TYPE } = constants;
import { getCustomContextMetadata, trackConvivaCustomEvent } from "../../shared/analytics/media";

function ToastNotification(props) {
  const { showToastNotification, appProvider, userProfile, isInHome } = props;
  const { toastData, featureToggles } = useReducers(REDUCER_TYPE.APP);
  const [toast, setToast] = useState(false);
  const [toastClass, setToastClass] = useState(false);
  const { t: translate } = useTranslation();
  const { isConvivaAppTrackerEnabled, isDynatraceTrackingEnabled } = featureToggles;

  useEffect(() => {
    if (toastData && Object.values(toastData).some((value) => value !== null)) {
      setToast(true);
      setToastClass(true);

      const message = toastData.message;
      if (
        translate("message_in_home") === message ||
        translate("error_outside_region") === message ||
        translate("android_error_outside_region_2") === message ||
        translate("error_program_not_available_region") === message
      ) {
        trackGenericAction(ANALYTICS_EVENT_TYPES.GEO_BLOCKED_ERROR, { message }, isDynatraceTrackingEnabled);
      } else if (toastData.message === translate("not_subscribed_restriction")) {
        trackGenericAction(
          ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
          {
            media: toastData.analyticsInfo?.media,
            message,
          },
          isDynatraceTrackingEnabled
        );
        if (isConvivaAppTrackerEnabled) {
          trackConvivaCustomEvent(
            ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
            getCustomContextMetadata(toastData.analyticsInfo?.media, userProfile, appProvider, isInHome)
          );
        }
      } else if (toastData.message === translate("error_browser_restriction")) {
        trackGenericAction(
          ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
          {
            media: toastData.analyticsInfo?.media,
            notificationType: NOTIFICATION_TYPES.ALERTS,
            message,
          },
          isDynatraceTrackingEnabled
        );
        if (isConvivaAppTrackerEnabled) {
          trackConvivaCustomEvent(
            ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
            getCustomContextMetadata(toastData.analyticsInfo?.media, userProfile, appProvider, isInHome)
          );
        }
      } else if (toastData.message === translate("panic_mode_enabled")) {
        trackGenericAction(
          ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
          {
            notificationType: NOTIFICATION_TYPES.ALERTS,
            message,
          },
          isDynatraceTrackingEnabled
        );
        if (isConvivaAppTrackerEnabled) {
          trackConvivaCustomEvent(
            ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
            getCustomContextMetadata(toastData.analyticsInfo?.media, userProfile, appProvider, isInHome)
          );
        }
      } else if (toastData.message && !toastData.message.toLowerCase().includes("record")) {
        trackGenericAction(ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS, { message }, isDynatraceTrackingEnabled);
        if (isConvivaAppTrackerEnabled) {
          trackConvivaCustomEvent(
            ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
            getCustomContextMetadata(toastData.analyticsInfo?.media, userProfile, appProvider, isInHome)
          );
        }
      }

      const timeout = setTimeout(() => {
        setToastClass(false);
        showToastNotification(null, null, null);
      }, 5000);
      return () => clearTimeout(timeout);
    }
  }, [
    toastData,
    showToastNotification,
    translate,
    appProvider,
    userProfile,
    isInHome,
    isConvivaAppTrackerEnabled,
    isDynatraceTrackingEnabled,
  ]);

  return toast && toastData ? (
    <ToastContainer className={toastClass ? "show" : ""} dark={toastData.dark}>
      {toastData.icon && (
        <div className="icon-wrapper">
          <img src={toastData.icon} alt="" />
        </div>
      )}
      <div>{toastData.message}</div>
    </ToastContainer>
  ) : null;
}

const mapDispatchToProps = {
  showToastNotification,
};

export default connect(null, mapDispatchToProps)(ToastNotification);
